<template>
  <v-layout justify-left row wrap>
    <v-flex xs12>
        <v-tabs fixed-tabs show-arrows dark color="grey lighten-1">
          <v-tab v-for="(topic, key) in topics" :key="key" ripple :to="topic.to">
            <div><v-icon small :class="['fas', topic.icon]"></v-icon><span class="hidden-xs-only">&nbsp;&nbsp;{{ topic.title }}</span></div>
          </v-tab>
        </v-tabs>
        <v-parallax src="static/bigstock-Seminar-7799082.jpg" height="300">
          <h2>Management Development</h2>
        </v-parallax>
        <div class="cta-block">Let us customize <router-link to="/contact">a solution for you</router-link></div>
        <v-card>
          <v-container fluid>
            <v-layout row wrap>
              <h3 class="sub-header">Developing Managers Requires a Wide Array of Skills</h3>
              <p>There are many different modules available for management development, which include the following content areas:</p>
              <div class="list-columns">
                Time management<br />
                Transitioning from a peer to a supervisor<br />
                The primary roles of a supervisor<br />
                Conflict resolution<br />
                Delivering constructive feedback<br />
                Praise<br />
                Delegation skills<br />
                Situational leadership<br />
                Communication skills<br />
                Behavioral based interviewing<br />
                Performance management<br />
                Train the trainer<br />
                Evaluating the effectiveness of training<br />
                Coaching<br />
                Delivering tough messages with tact<br />
              </div>
            </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'management',
  data () {
    return {
      topics: [
        {
          title: 'Business Development / Sales',
          icon: 'fa-university',
          excerpt: 'Offering courses that teach your staff to become better business builders through stronger customer relationships, better performance evaluation and bonded team dynamics.',
          to: '/topics/business'
        },
        {
          title: 'Leadership Development',
          icon: 'fa-hand-point-right',
          excerpt: 'Learn the difference between being a manager and being a leader, and how to talk to people at all levels of the organization in ways that engage and strengthen.',
          to: '/topics/leadership'
        },
        {
          title: 'Team Development',
          icon: 'fa-users',
          excerpt: 'Organizations need to learn how to build cohesive teams if they expect to build a sustainable business enterprise by guaging the members.',
          to: '/topics/team'
        },
        {
          title: 'Management Development',
          icon: 'fa-user-tie',
          excerpt: 'Each manager is as individual in style as they are in personality. Each manager can develop those individual traits to their best advantage.',
          to: '/topics/management'
        }
      ]
    }
  }
}
</script>

<style>
.list-columns {
  width: 100%;
  column-count: 1;
}
@media all and (min-width: 480px) {
  .list-columns {
    column-count: 2;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/topics/Management.vue